module.exports = __webpack_public_path__ + "static/media/logo_documents.674c46a5.png";